module.exports = __webpack_public_path__ + "77d73803c297803c501e7da8d4000331.svg";